import { createElement } from 'react';

import type { IconProps } from '../icon/icon';
import { Icon } from '../icon/icon'; // props is just passed in to keep variables.jsx happy. We don’t use variables.props
const SvgKebabIcon = (componentProps: IconProps, props = {}) => {
  return createElement(
    Icon,
    componentProps,
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 32 32"
      {...props}
    >
      <path
        fill="#353C4A"
        d="M18 24a2 2 0 1 1-4 0 2 2 0 0 1 4 0M18 8a2 2 0 1 1-4 0 2 2 0 0 1 4 0M18 16a2 2 0 1 1-4 0 2 2 0 0 1 4 0"
      />
    </svg>,
  );
};
export default SvgKebabIcon;
